import React from 'react';
import { Bot } from 'lucide-react';

/**
 * Bouton flottant « Explique-moi » (coordonnées viewport pour position: fixed).
 */
export default function FloatingAIButton({
  x,
  y,
  visible,
  label = 'Explique-moi',
  onClick,
  buttonRef = undefined,
}) {
  if (!visible) return null;

  const btnW = 148;
  const btnH = 40;
  const left = Math.min(
    window.innerWidth - btnW - 8,
    Math.max(8, x - btnW / 2),
  );
  const top = Math.max(8, y - btnH - 6);

  return (
    <button
      ref={buttonRef}
      type="button"
      className="reader-floating-ai-btn"
      style={{ left, top }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick?.();
      }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <Bot size={16} aria-hidden />
      <span>{label}</span>
    </button>
  );
}
